/* eslint-disable no-extra-boolean-cast */
/* eslint-disable prefer-template */
import { GET_MY, REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { BtwOrMarge } from '../Invoices/constants';
import {
  FETCH_MMT,
  INITIATE_VEHICLE_CREATE,
  INITIATE_VEHICLE_EDIT,
  REMOVE_ALL_VEHICLE_FROM_BULK_ACTIONS_LIST,
  REMOVE_VEHICLE_FROM_BULK_ACTIONS_LIST,
  REQUEST_ADD_EXTRA_COST_BULK,
  REQUEST_ADD_SUPPLIER,
  REQUEST_AUTOTELEX_SEARCH,
  REQUEST_BPM_PRICE_LIST,
  REQUEST_DELETE_VEHICLE,
  REQUEST_DOWNLOAD_ZIP_FILES,
  REQUEST_GENERATE_INCOMING_BPM_INVOICE,
  REQUEST_GENERATE_INCOMING_INVOICE,
  REQUEST_GENERATE_OUTGOING_BPM_INVOICE,
  REQUEST_GENERATE_OUTGOING_INVOICE,
  REQUEST_IMPORT_VEHICLE,
  REQUEST_REMOVE_SUPPLIER,
  REQUEST_SILVERDAT_GET,
  REQUEST_UPDATE_VEHICLE_SEARCH_SETTINGS,
  REQUEST_VEHICLE,
  REQUEST_VEHICLES,
  REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER,
  REQUEST_VEHICLE_ASSIGN_TRANSPORT,
  REQUEST_BULK_ACTION_VEHICLE_ASSIGN_TRANSPORT,
  REQUEST_VEHICLE_BPM_ESTIMATE,
  REQUEST_VEHICLE_COMPLETE_TRANSPORT,
  REQUEST_VEHICLE_CREATE,
  REQUEST_VEHICLE_DOWNLOAD_IMAGES,
  REQUEST_VEHICLE_FILTER,
  REQUEST_VEHICLE_FILTER_RESET,
  REQUEST_VEHICLE_FROM_AUTOTELEX,
  REQUEST_VEHICLE_HISTORY,
  REQUEST_VEHICLE_OPTIONS,
  REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION,
  REQUEST_VEHICLE_PROPERTIES,
  REQUEST_VEHICLE_PROPERTY,
  REQUEST_VEHICLE_PROPERTY_DELETE,
  REQUEST_VEHICLE_PROPERTY_NAMES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE_SEARCH_SETTINGS,
  REQUEST_VEHICLE_TASKS,
  RETRIEVE_REGPLATE,
  SET_NEW_ORDER_VALUE,
  SET_NEW_VEHICLE,
  SET_NEW_VEHICLE_VALUE,
  REQUEST_VEHICLE_DOCUMENTS_BY_TYPE,
  SET_VEHICLES_SORT,
  SET_VEHICLE_LOCATION,
  ALL_OPTIONS,
  HEXON_WEBSITES,
  HEXON_ADS_FOR,
  HEXON,
  VEHICLES_DOMAIN,
  CALCULATE_PURCHASE_PRICES_BTW,
  CALCULATE_PURCHASE_PRICES_MARGE,
  CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
  INITIATE_NEW_ORDER_CREATE,
  ADD_VEHICLE_TO_BULK_ACTIONS_LIST,
  REQUEST_UPDATE_SELECTED_VEHICLES,
  SHARE_EXCEL_VEHICLE_DATA,
  SILVERDAT_DATA,
  UPDATE_VEHICLE_SEARCH_STRING,
  UPDATE_VEHICLE_FILTERS,
  APPLY_VEHICLE_FILTERS,
  FETCH_HEMEX_STATUS,
  HEMEX_STATUS,
  CREATE_HEMEX_INSPECTION,
  HEXON_IMAGES_FOR,
  HEXON_DELETE_IMAGE,
  HEXON_RECREATE_IMAGES,
  REQUEST_CAR_COLLECT_CREATE,
  REQUEST_CAR_COLLECT,
  REQUEST_AUTOTELEX_APPLY_OPTIONS,
  SET_NEW_VEHICLE_OPTIONS,
  COPY_VEHICLE_OPTIONS_TO_TARGET_VEHICLE,
  REQUEST_VEHICLES_DOCUMENTS_BY_TYPE,
  COPY_VEHICLE_GENERAL_PHOTOS_TO_TARGET_VEHICLE,
  REQUEST_VEHICLE_INVOICES_ATTACHMENTS,
  REQUEST_CAR_COLLECT_AWARDS,
  ADD_CAR_COLLECT_INVOICE,
  ADD_CAR_COLLECT_DOCUMENT,
  REQUEST_OREH_VEHICLE_EXPORT,
  REQUEST_VEHICLE_RECOMMENDATIONS,
  UPDATE_HISTORY_FILTER,
  UPDATE_HISTORY_SEARCH_STRING,
  SWITCH_VEHICLE_RDW_DATES,
  COPY_VEHICLE,
  // Workflow management
  REQUEST_VEHICLE_WORKFLOW_TASKS,
  ASSIGN_WORKFLOW_TO_VEHICLE,
} from './constants';
import { formatAmount, formatFinancialAmounts } from './helpers';

export function deleteVehicle(vehicleId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DELETE_VEHICLE,
    gate: REQUEST_DELETE_VEHICLE + vehicleId,
    delete: {},
    path: `vehicles/${vehicleId}`,
    putOnComplete: [fetchVehicles()],
    callback,
  };
}

export function getMMT() {
  return {
    type: FETCH_MMT,
  };
}

export function fetchVehicles(offset = 0, limit = 200) {
  return {
    type: REQUEST_VEHICLE_FILTER,
  };
}

export function addVehicleToBulkActionsList(vehicle = null, vehicles = [], kanbanTaskName = null, page = null) {
  return {
    type: ADD_VEHICLE_TO_BULK_ACTIONS_LIST,
    payload: vehicle,
    vehicles,
    page,
    kanbanTaskName,
  };
}

export function removeVehicleFromBulkActionsList(vehicleId, page = null) {
  return {
    type: REMOVE_VEHICLE_FROM_BULK_ACTIONS_LIST,
    vehicleId,
    page,
  };
}

export function removeAllVehicleFromBulkActionsList(callback, page = null) {
  return {
    type: REMOVE_ALL_VEHICLE_FROM_BULK_ACTIONS_LIST,
    page,
    callback,
  };
}

export function updateSelectedVehicles(vehicleIds, propertiesArr, callback) {
  return {
    type: GET_MY,
    post: {
      ids: vehicleIds,
      properties: propertiesArr,
    },
    work: REQUEST_UPDATE_SELECTED_VEHICLES,
    gate: REQUEST_UPDATE_SELECTED_VEHICLES,
    callback,

    path: `/vehicles-bulk-actions/properties`,
  };
}

export function fetchVehiclePropertyNames() {
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_PROPERTY_NAMES,
    work: REQUEST_VEHICLE_PROPERTY_NAMES,
    path: `vehicles/propertyNames`,
  };
}

export function fetchVehicle(vehicleId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE,
    vehicleId,
    work: [REQUEST_VEHICLE, `${REQUEST_VEHICLE}-${vehicleId}`],
    gate: REQUEST_VEHICLE + vehicleId,
    path: `vehicles/${vehicleId}`,
    callback,
  };
}

export function fetchAllOptions() {
  return {
    type: GET_MY,
    id: ALL_OPTIONS,
    work: ALL_OPTIONS,
    gate: ALL_OPTIONS,
    path: `customer/vehicles/options`,
  };
}

export const fillVehicleProperty = (vehicleId, propertyName, result) => ({
  type: REQUEST_DATA_RESULT,
  id: REQUEST_VEHICLE_PROPERTY,
  vehicleId,
  propertyName,
  result,
});

export function fetchVehicleProperty(vehicleId, propertyName, callback) {
  let work = REQUEST_VEHICLE_PROPERTY + '-' + propertyName + '-' + vehicleId;
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_PROPERTY,
    propertyName,
    vehicleId,
    work: [work],
    gate: work,
    path: `/vehicles/${vehicleId}/properties/${propertyName}`,
    callback,
  };
}

export function setVehicleProperty(vehicleId, name, propertyValue, callback, options) {
  let work = REQUEST_VEHICLE_PROPERTY_UPDATE + '-' + name;
  let workTaskRemarks = options?.taskRemarks ? REQUEST_VEHICLE_PROPERTY_UPDATE + '-' + 'taskRemarks' : '';

  let works = [work, workTaskRemarks];

  if (!options?.loadingProperty) {
    works?.push(REQUEST_VEHICLE_PROPERTY_UPDATE);
  }
  return {
    type: GET_MY,
    post: {
      propertyValue,
    },
    name,
    vehicleId,
    propertyValue,
    work: works,
    gate: REQUEST_VEHICLE_PROPERTY_UPDATE + vehicleId + name,
    path: `/vehicles/${vehicleId}/properties/${name}`,
    putOnComplete: [
      {
        ...fetchVehicleProperties(vehicleId),
        work,
        callback,
      },
    ],
  };
}

export function updateRestBpmRequest(invoiceId, vehicleId, properties, callback) {
  let work = REQUEST_VEHICLE_PROPERTY_UPDATE;
  return {
    type: GET_MY,
    patch: {
      properties,
    },
    work,
    gate: REQUEST_VEHICLE_PROPERTY_UPDATE + vehicleId,
    path: `/vehicles/${vehicleId}/properties`,
    putOnComplete: [
      {
        ...fetchVehicleProperties(vehicleId),
        work,
        callback,
      },
    ],
  };
}

export function setVehicleProperties(vehicleId, properties, callback, options = {}) {
  properties = formatFinancialAmounts(properties);

  let path = `/vehicles/${vehicleId}/properties`;

  if (options?.addLinkedProducts) {
    path += `?addLinkedProducts=true`;
  }

  let work = REQUEST_VEHICLE_PROPERTY_UPDATE;
  return {
    type: GET_MY,
    patch: {
      properties,
    },
    work,
    gate: REQUEST_VEHICLE_PROPERTY_UPDATE + vehicleId,
    path,
    putOnComplete: [
      {
        ...fetchVehicleProperties(vehicleId),
        work,
        callback,
      },
    ],
  };
}

export function addSupplier(vehicleId, data, callback) {
  return {
    type: GET_MY,
    post: data,
    vehicleId,
    work: REQUEST_ADD_SUPPLIER,
    gate: REQUEST_ADD_SUPPLIER + vehicleId,
    callback,
    path: `/vehicles/${vehicleId}/supplier`,
    putOnComplete: [fetchVehicle(vehicleId)],
  };
}

export function removeSupplier(vehicleId, data, callback) {
  return {
    type: GET_MY,
    delete: {},
    vehicleId,
    work: REQUEST_REMOVE_SUPPLIER,
    gate: REQUEST_REMOVE_SUPPLIER + vehicleId,
    callback,
    path: `/vehicles/${vehicleId}/supplier`,
    putOnComplete: [fetchVehicle(vehicleId)],
  };
}

export function deleteVehicleProperty(vehicleId, propertyName, callback) {
  let work = REQUEST_VEHICLE_PROPERTY_UPDATE + '-' + propertyName;
  return {
    type: GET_MY,
    delete: {},
    vehicleId,
    work: [REQUEST_VEHICLE_PROPERTY_UPDATE, work],
    gate: REQUEST_VEHICLE_PROPERTY_UPDATE + vehicleId + propertyName,
    id: REQUEST_VEHICLE_PROPERTY_DELETE,
    propertyName,
    path: `/vehicles/${vehicleId}/properties/${propertyName}`,
    putOnComplete: [
      {
        //should be ;
        ...fetchVehicleProperties(vehicleId),
        //...(light ? fetchVehicleProperties(vehicleId) : fetchVehicle(vehicleId)),
        work: [work],
        callback,
      },
    ],
  };
}

export function createVehicleWithProps(properties, options, callback) {
  const acceptCopy = options[0]?.acceptedForDuplicate;
  const optionsToSend = !!acceptCopy ? [] : options;
  const workflowId = properties.find(p => p.propertyName === 'workflowId' && !!p.propertyValue)?.propertyValue;
  properties = properties.filter(p => p.propertyName !== 'workflowId');
  //filter out some property errors
  properties = properties.filter(
    p =>
      p.propertyName != 'validationErrors' &&
      p.propertyName != 'bijtellingHelpText' &&
      p.propertyName.toLowerCase?.() != 'id' &&
      p.propertyValue !== '',
  );
  const post = {
    properties,
    options: optionsToSend,
    acceptedForDuplicate: acceptCopy ?? null,
  };
  if (workflowId) post.workflowId = workflowId;

  return {
    type: GET_MY,
    post,
    work: REQUEST_VEHICLE_CREATE,
    gate: REQUEST_VEHICLE_CREATE,
    path: `vehicles/create`,
    callback,
  };
}

export function fromAutotelex(vehicleId, regplate, callback) {
  if (!regplate) throw 'no regplate';
  if (!vehicleId) throw 'no vehicleId';
  let work = REQUEST_VEHICLE_FROM_AUTOTELEX;
  return {
    ...setVehicleProperty(vehicleId, 'regplate', regplate),
    work,
    putOnComplete: {
      type: GET_MY,
      work,
      gate: REQUEST_VEHICLE_FROM_AUTOTELEX + vehicleId,
      path: `vehicles/${vehicleId}/autotelex`,
      putOnComplete: [
        {
          ...fetchVehicle(vehicleId),
          work,
          putOnComplete: [initiateVehicleEdit(vehicleId)],
        },
      ],
      callback,
    },
  };
}

export function applyAutotelexOptionsToVehicle(vehicleId, regplate, callback) {
  let work = REQUEST_AUTOTELEX_APPLY_OPTIONS;
  return {
    type: GET_MY,
    work,
    gate: REQUEST_AUTOTELEX_APPLY_OPTIONS + vehicleId,
    post: {
      vehicleId,
      regplate,
    },
    path: `autotelex/apply-options`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function applyVehicleFilters() {
  return {
    type: APPLY_VEHICLE_FILTERS,
  };
}

export function changeVehicleFilter(name, value) {
  return {
    type: REQUEST_VEHICLE_FILTER,
    name,
    value,
  };
}

export function setVehiclesSort(sortType, order) {
  return {
    type: SET_VEHICLES_SORT,
    sortType,
    order,
  };
}

export function resetVehicleFilter() {
  return {
    type: REQUEST_VEHICLE_FILTER_RESET,
  };
}

export function updateVehicleFilter(propertyFilter, options) {
  return {
    type: UPDATE_VEHICLE_FILTERS,
    propertyFilter,
    ...options,
  };
}

export function updateWithFetchVehicleFilter(propertyFilter, options) {
  return {
    type: REQUEST_VEHICLE_FILTER,
    propertyFilter,
    options: {
      skipFilter: true,
    },
  };
}

export function updateSearchString(searchString) {
  return {
    type: UPDATE_VEHICLE_SEARCH_STRING,
    searchString,
  };
}

export function changeVehiclePropertyFilter(propertyFilter, options) {
  return {
    type: REQUEST_VEHICLE_FILTER,
    propertyFilter,
    ...options,
  };
}

export function searchAutotelex(searchDto, callback) {
  let path = 'autotelex/search';
  const query = new URLSearchParams(searchDto).toString(searchDto);
  if (query !== '') {
    path += `?${query}`;
  }

  return {
    type: GET_MY,
    work: REQUEST_AUTOTELEX_SEARCH,
    gate: REQUEST_AUTOTELEX_SEARCH,
    path,
    putOnComplete: [],
    callback,
  };
}

export function importVehicle(searchDto, callback) {
  let path = 'vehicles/import/data';
  const query = new URLSearchParams(searchDto).toString(searchDto);
  if (query !== '') {
    path += `?${query}`;
  }

  return {
    type: GET_MY,
    work: REQUEST_IMPORT_VEHICLE,
    gate: REQUEST_IMPORT_VEHICLE,
    path,
    putOnComplete: [],
    callback,
  };
}

export function getBpmEstimate(vehicleId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_BPM_ESTIMATE,
    vehicleId,
    work: REQUEST_VEHICLE_BPM_ESTIMATE,
    gate: REQUEST_VEHICLE_BPM_ESTIMATE + vehicleId,
    callback,
    path: `vehicles/${vehicleId}/bpm-estimate`,
  };
}

export function getVehicleSearchSettings(callback) {
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_SEARCH_SETTINGS,
    work: REQUEST_VEHICLE_SEARCH_SETTINGS,
    gate: REQUEST_VEHICLE_SEARCH_SETTINGS,
    callback,
    path: `settings/vehicle-search`,
  };
}

export function updateVehicleSearchSettings(data, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_VEHICLE_SEARCH_SETTINGS,
    work: REQUEST_UPDATE_VEHICLE_SEARCH_SETTINGS,
    gate: REQUEST_UPDATE_VEHICLE_SEARCH_SETTINGS,
    put: data,
    path: `settings/vehicle-search`,
    callback,
  };
}

export function BPMPriceList(data, callback) {
  return {
    type: GET_MY,
    id: REQUEST_BPM_PRICE_LIST,
    work: REQUEST_BPM_PRICE_LIST,
    gate: REQUEST_BPM_PRICE_LIST,
    post: data,
    path: `vehicles/bpm-pricelist`,
    callback,
    options: {
      timeout: 180000,
    },
  };
}

export function setNewVehicleValue(name, value) {
  console.log('action setNewVehicleValue', { name, value });
  return {
    type: SET_NEW_VEHICLE_VALUE,
    name,
    value,
  };
}

export function setNewVehicle(data, reset) {
  return {
    type: SET_NEW_VEHICLE,
    data,
    reset,
  };
}
export function setNewVehicleOptions(options) {
  return {
    type: SET_NEW_VEHICLE_OPTIONS,
    options,
  };
}

export function initiateNewVehicleValue(name) {
  return {
    type: SET_NEW_VEHICLE_VALUE,
    name,
    initiate: true,
  };
}

export function initiateVehicleEdit(id) {
  return {
    type: INITIATE_VEHICLE_EDIT,
    id,
  };
}

export function initiateVehicleCreate() {
  return {
    type: INITIATE_VEHICLE_CREATE,
  };
}

export function setNewOrderValue(name, value) {
  return {
    type: SET_NEW_ORDER_VALUE,
    name,
    value,
  };
}
export function initiateNewOrderValue(name) {
  return {
    type: SET_NEW_ORDER_VALUE,
    name,
    initiate: true,
  };
}

export function initiateNewOrder() {
  return {
    type: INITIATE_NEW_ORDER_CREATE,
  };
}

export function addVehicleToOutgoingOrder(vehicleId, properties, options, callback) {
  let work = REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER;
  let path = `/vehicles/${vehicleId}/add-to-outgoing-order`;
  if (options.applyDefaultTasks) path = `${path}?applyDefaultTasks=true`;

  return {
    type: GET_MY,
    post: properties,
    vehicleId,
    work,
    gate: REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER + vehicleId,
    path,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function generateIncomingInvoice(vehicleId, callback = () => {}, options = {}) {
  return {
    type: GET_MY,
    post: {
      copyProductSubjectsFrom: options?.copyProductSubjectsFrom,
    },
    id: REQUEST_GENERATE_INCOMING_INVOICE,
    work: REQUEST_GENERATE_INCOMING_INVOICE,
    gate: REQUEST_GENERATE_INCOMING_INVOICE,
    path: `vehicles/${vehicleId}/generate-incoming-invoice`,
    putOnComplete: fetchVehicle(vehicleId),
    callback,
  };
}

export function generateOutgoingInvoice(vehicleId, input) {
  return {
    type: GET_MY,
    post: input,
    id: REQUEST_GENERATE_OUTGOING_INVOICE,
    work: REQUEST_GENERATE_OUTGOING_INVOICE,
    gate: REQUEST_GENERATE_OUTGOING_INVOICE,
    path: `vehicles/${vehicleId}/generate-outgoing-invoice`,
    putOnComplete: fetchVehicle(vehicleId),
  };
}

export function generateIncomingBpmInvoice(vehicleId, input) {
  return {
    type: GET_MY,
    post: input,
    id: REQUEST_GENERATE_INCOMING_BPM_INVOICE,
    work: REQUEST_GENERATE_INCOMING_BPM_INVOICE,
    gate: REQUEST_GENERATE_INCOMING_BPM_INVOICE,
    path: `vehicles/${vehicleId}/generate-incoming-bpm-invoice`,
    putOnComplete: fetchVehicle(vehicleId),
  };
}

export function generateOutgoingBpm(vehicleId, input) {
  input.restBPMAmount = formatAmount(input?.restBPMAmount);
  return {
    type: GET_MY,
    post: input,
    id: REQUEST_GENERATE_OUTGOING_BPM_INVOICE,
    work: REQUEST_GENERATE_OUTGOING_BPM_INVOICE,
    gate: REQUEST_GENERATE_OUTGOING_BPM_INVOICE,
    path: `vehicles/${vehicleId}/generate-outgoing-bpm-invoice`,
    putOnComplete: fetchVehicle(vehicleId),
  };
}

export function getOutgoingRestBpmCalculation(vehicleId) {
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION,
    work: REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION,
    gate: REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION,
    path: `vehicles/${vehicleId}/current-rest-bpm`,
  };
}

export function addVehicleOption(vehicleId, optionId, callback) {
  let work = `vehicle-option-${optionId}`;
  return {
    type: GET_MY,
    work,
    put: {},
    gate: `add-option-${vehicleId}-${optionId}`,
    path: `vehicles/${vehicleId}/options/${optionId}`,
    putOnComplete: [
      {
        ...fetchVehicleOptions(vehicleId),
        work,
        callback,
      },
    ],
  };
}

export function removeVehicleOption(vehicleId, optionId, callback) {
  let work = `vehicle-option-${optionId}`;
  return {
    type: GET_MY,
    work,
    delete: {},
    gate: `delete-option-${vehicleId}-${optionId}`,
    path: `vehicles/${vehicleId}/options/${optionId}`,
    putOnComplete: [
      {
        ...fetchVehicleOptions(vehicleId),
        work,
        callback,
      },
    ],
  };
}

export function fetchVehicleOptions(vehicleId, callback) {
  return {
    vehicleId,
    type: GET_MY,
    id: REQUEST_VEHICLE_OPTIONS,
    work: REQUEST_VEHICLE_OPTIONS,
    gate: `fetch-options-${vehicleId}`,
    path: `vehicles/${vehicleId}/options`,
    callback,
  };
}

export function fetchVehicleProperties(vehicleId, callback) {
  let name = `${REQUEST_VEHICLE_PROPERTIES}-${vehicleId}`;
  return {
    vehicleId,
    type: GET_MY,
    id: REQUEST_VEHICLE_PROPERTIES,
    work: name,
    gate: name,
    path: `vehicles/${vehicleId}/properties`,
    callback,
  };
}

export function setVehicleLocation(vehicleId, companyId, addressId, callback) {
  return {
    type: GET_MY,
    patch: {
      locationCompanyId: companyId ?? 0,
      locationAddressId: addressId ?? 0,
    },
    work: SET_VEHICLE_LOCATION,
    gate: SET_VEHICLE_LOCATION + vehicleId,
    path: `/vehicles/${vehicleId}/location`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function calculatePurchasePricesBTW(vehicleId, enteredAmounts, vehicle_purpose, callback) {
  return {
    id: CALCULATE_PURCHASE_PRICES_BTW,
    type: GET_MY,
    work: CALCULATE_PURCHASE_PRICES_BTW,
    gate: CALCULATE_PURCHASE_PRICES_BTW + vehicleId,
    path: `/vehicles/${vehicleId}/calculate-purchase-financial-amounts/${BtwOrMarge.BTW}`,
    post: { ...enteredAmounts, vehicle_purpose },
    callback,
  };
}

export function calculatePurchasePricesMARGE(vehicleId, enteredAmounts, vehicle_purpose, callback) {
  return {
    id: CALCULATE_PURCHASE_PRICES_MARGE,
    type: GET_MY,
    work: CALCULATE_PURCHASE_PRICES_MARGE,
    gate: CALCULATE_PURCHASE_PRICES_MARGE + vehicleId,
    path: `/vehicles/${vehicleId}/calculate-purchase-financial-amounts/${BtwOrMarge.MARGE}`,
    post: { ...enteredAmounts, vehicle_purpose },
    callback,
  };
}

export function calculatePurchasePriceInclVatExclBPM(enteredAmounts, callback) {
  return {
    id: CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
    type: GET_MY,
    work: CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
    gate: CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
    path: `/accounting/calculate-purchase-amounts`,
    post: enteredAmounts,
    callback,
  };
}

export function fetchHexonWebsites(callback) {
  return {
    type: GET_MY,
    id: HEXON_WEBSITES,
    work: HEXON,
    gate: HEXON_WEBSITES,
    path: `/hexon/websites`,
    callback,
  };
}

export function fetchHexonAdsFor(vehicle_id, callback) {
  return {
    type: GET_MY,
    id: HEXON_ADS_FOR,
    work: HEXON,
    gate: HEXON_ADS_FOR,
    vehicle_id,
    path: `/hexon/ads/${vehicle_id}`,
    callback,
  };
}

export function fetchHexonImagesFor(vehicle_id, callback) {
  return {
    type: GET_MY,
    id: HEXON_IMAGES_FOR,
    work: `${HEXON_IMAGES_FOR}-${vehicle_id}`,
    gate: `${HEXON_IMAGES_FOR}-${vehicle_id}`,
    vehicle_id,
    path: `/hexon/images/${vehicle_id}`,
    callback,
  };
}

export function deleteHexonImage(vehicle_id, nr, callback) {
  return {
    type: GET_MY,
    work: [HEXON, `HEXON-${vehicle_id}`],
    gate: HEXON_DELETE_IMAGE,
    vehicle_id,
    delete: {},
    path: `/hexon/images/${vehicle_id}/${nr}`,
    putOnComplete: fetchHexonImagesFor(vehicle_id, callback),
    callback,
  };
}

export function hexonRecreateImages(vehicle_id, callback) {
  return {
    type: GET_MY,
    work: [HEXON, `HEXON-${vehicle_id}`],
    gate: `${HEXON_RECREATE_IMAGES}-${vehicle_id}`,
    vehicle_id,
    post: {},
    path: `/hexon/images/${vehicle_id}/recreate`,
    putOnComplete: fetchHexonImagesFor(vehicle_id, callback),
    callback,
  };
}

export function hexonReloadAll(callback) {
  return {
    type: GET_MY,
    work: HEXON,
    gate: HEXON,
    path: `/hexon/ads/reload-all`,
    callback,
  };
}

export function hexonCreateAd(vehicle_id, site_code, callback) {
  return {
    type: GET_MY,
    work: [HEXON, `HEXON-${vehicle_id}-${site_code}`],
    gate: HEXON_ADS_FOR,
    post: {
      vehicle_id,
      site_code,
    },
    vehicle_id,
    path: `/hexon/ads/create`,
    callback,
  };
}
export function hexonCreateAds(vehicle_id, site_codes, callback) {
  return {
    type: GET_MY,
    work: [HEXON, `HEXON-${vehicle_id}-${site_codes}`],
    gate: HEXON_ADS_FOR,
    post: {
      vehicle_id,
      site_codes,
    },
    vehicle_id,
    path: `/hexon/ads/create-multi`,
    callback,
  };
}

export function hexonDeleteAd(vehicle_id, site_code, callback) {
  return {
    type: GET_MY,
    work: [HEXON, `HEXON-${vehicle_id}-${site_code}`],
    gate: HEXON_ADS_FOR,
    delete: {},
    path: `/hexon/ads/disable/${vehicle_id}/${site_code}`,
    putOnComplete: [fetchHexonAdsFor(vehicle_id)],
    callback,
  };
}

export function hexonDeleteAllAdsFor(vehicle_id, callback) {
  return {
    type: GET_MY,
    work: HEXON,
    gate: HEXON_ADS_FOR,
    delete: {},
    path: `/hexon/ads/disable/${vehicle_id}/all`,
    putOnComplete: [fetchHexonAdsFor(vehicle_id)],
    callback,
  };
}

export function hexonEnable(vehicle_id, callback) {
  return {
    type: GET_MY,
    work: HEXON,
    gate: HEXON_ADS_FOR,
    post: {},
    path: `/hexon/ads/${vehicle_id}/enable`,
    putOnComplete: [fetchHexonAdsFor(vehicle_id), fetchVehicle(vehicle_id)],
    callback,
  };
}

export function assignVehicleTransport(vehicleId, assign_to, outgoing, individual, callback) {
  return {
    type: GET_MY,
    post: {
      assign_to,
      outgoing,
      individual,
    },
    work: REQUEST_VEHICLE_ASSIGN_TRANSPORT,
    gate: REQUEST_VEHICLE_ASSIGN_TRANSPORT + vehicleId,
    path: `/vehicles/${vehicleId}/transport/assign`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function bulkActionAssignVehicleTransport(vehicleIds, assign_to, outgoing, individual, callback) {
  return {
    type: GET_MY,
    post: {
      ids: vehicleIds,
      assign_to,
      outgoing,
      individual,
    },
    gate: REQUEST_BULK_ACTION_VEHICLE_ASSIGN_TRANSPORT,
    work: REQUEST_BULK_ACTION_VEHICLE_ASSIGN_TRANSPORT,
    path: `/vehicles-bulk-actions/transport/assign`,
    callback,
  };
}

export function assignVehicleTasks(vehicleId, assign_to, tasks, taskname, callback) {
  return {
    type: GET_MY,
    post: {
      assign_to,
      tasks,
      taskname,
    },
    work: REQUEST_VEHICLE_ASSIGN_TRANSPORT,
    gate: REQUEST_VEHICLE_ASSIGN_TRANSPORT + vehicleId,
    path: `/vehicles/${vehicleId}/transport/assign`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function completeVehicleTransport(vehicleId, outgoing, individual, action_name, callback) {
  return {
    type: GET_MY,
    post: { outgoing, individual, action_name },
    work: REQUEST_VEHICLE_COMPLETE_TRANSPORT,
    gate: REQUEST_VEHICLE_COMPLETE_TRANSPORT + vehicleId,
    path: `/vehicles/${vehicleId}/transport/complete`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function downloadImages(vehicleId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_VEHICLE_DOWNLOAD_IMAGES,
    gate: REQUEST_VEHICLE_COMPLETE_TRANSPORT + vehicleId,
    path: `/vehicles/${vehicleId}/download-images`,
    callback,
  };
}

export function vehicleSearch(text, callback) {
  let path = `vehicles/getList`;

  const searchParams = {
    offset: 0,
    limit: 50,
    text,
    filters: [],
  };

  return {
    type: GET_MY,
    work: REQUEST_VEHICLES,
    gate: REQUEST_VEHICLES,
    path,
    post: searchParams,
    callback,
  };
}

export function getDocumentsByType(vehicleId, documentType, callback) {
  return {
    type: GET_MY,
    work: `${REQUEST_VEHICLE_DOCUMENTS_BY_TYPE}-${vehicleId}`,
    gate: REQUEST_VEHICLE_DOCUMENTS_BY_TYPE + vehicleId,
    path: `vehicles/${vehicleId}/documents/first-of-type/${documentType}`,
    callback,
  };
}

export function getDocumentsByTypeByIds(vehicleIds, documentType, callback) {
  const idsStr = vehicleIds.join('_');
  return {
    type: GET_MY,
    id: REQUEST_VEHICLES_DOCUMENTS_BY_TYPE,
    work: `${REQUEST_VEHICLES_DOCUMENTS_BY_TYPE}`,
    gate: REQUEST_VEHICLES_DOCUMENTS_BY_TYPE + idsStr,
    path: `vehicles/documents/first-of-type/${documentType}`,
    post: { ids: vehicleIds },
    callback,
  };
}

export function retrieveRegplate(regplate, callback) {
  let path = `vehicles/getList`;

  const searchParams = {
    offset: 0,
    limit: 50,
    text: regplate,
    filters: [],
  };

  return {
    type: GET_MY,
    work: RETRIEVE_REGPLATE,
    gate: RETRIEVE_REGPLATE,
    path,
    post: searchParams,
    callback,
  };
}

export function fetchVehicleHistory(vehicleId, text = '', properties, callback) {
  let path = `/entity-history/vehicle/${vehicleId}?offset=0&limit=9999&order=desc`;
  if (text) {
    path += `&text=${text}`;
  }
  if (properties?.length) {
    properties?.forEach(p => {
      return (path += `&fields=${p?.value}`);
    });
  }
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_HISTORY,
    work: REQUEST_VEHICLE_HISTORY,
    gate: REQUEST_VEHICLE_HISTORY + vehicleId,
    path: path,
    callback,
  };
}

export function updateHistoryFilter(properties = []) {
  return {
    type: UPDATE_HISTORY_FILTER,
    properties,
  };
}

export function updateHistorySearchString(text) {
  return {
    type: UPDATE_HISTORY_SEARCH_STRING,
    text,
  };
}

export function shareExcelVehicleData(dto, callback) {
  return {
    type: GET_MY,
    work: SHARE_EXCEL_VEHICLE_DATA,
    gate: SHARE_EXCEL_VEHICLE_DATA,
    post: dto,
    path: '/vehicles/export-vehicles-data',
    callback,
  };
}

export function fetchVehicleTasks(vehicleId, callback) {
  return {
    id: REQUEST_VEHICLE_TASKS,
    type: GET_MY,
    work: REQUEST_VEHICLE_TASKS,
    gate: REQUEST_VEHICLE_TASKS + vehicleId,
    path: `/actions/vehicle-tasks/${vehicleId}`,
    callback,
  };
}

export function downloadZipFiles(vehicleId, downloadFiles, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DOWNLOAD_ZIP_FILES,
    gate: REQUEST_DOWNLOAD_ZIP_FILES,
    post: downloadFiles,
    path: `/vehicles/${vehicleId}/download-files`,
    callback,
  };
}

export function addExtraCostBulk(dto, callback) {
  return {
    type: GET_MY,
    work: REQUEST_ADD_EXTRA_COST_BULK,
    gate: REQUEST_ADD_EXTRA_COST_BULK,
    post: dto,
    path: '/vehicles/add-extra-cost-bulk',
    callback,
  };
}

export function fetchHemexStatus(vehicleId) {
  return {
    type: GET_MY,
    work: FETCH_HEMEX_STATUS,
    gate: FETCH_HEMEX_STATUS,
    id: HEMEX_STATUS,
    vehicleId,
    path: `/vehicles/${vehicleId}/hemex-status`,
  };
}

export function createHemexInspection(vehicleId, regplate, date, callback) {
  return {
    type: GET_MY,
    work: CREATE_HEMEX_INSPECTION,
    gate: CREATE_HEMEX_INSPECTION,
    vehicleId,
    post: {
      regplate,
      date,
    },
    path: `/vehicles/${vehicleId}/hemex-create`,
    putOnComplete: [fetchHemexStatus(vehicleId), fetchVehicle(vehicleId)],
    callback,
  };
}

export function requestHemexAuction(vehicleId, callback) {
  return {
    type: GET_MY,
    work: CREATE_HEMEX_INSPECTION,
    gate: CREATE_HEMEX_INSPECTION,
    vehicleId,
    post: {},
    path: `/vehicles/${vehicleId}/hemex-auction`,
    putOnComplete: [fetchHemexStatus(vehicleId), fetchVehicle(vehicleId)],
    callback,
  };
}

export function silverdatGet(vehicleId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_SILVERDAT_GET,
    gate: REQUEST_SILVERDAT_GET,
    id: SILVERDAT_DATA,
    vehicleId,
    path: `/orb/silverdat/${vehicleId}`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}
export function silverdatSearch({ vin }, callback) {
  return {
    type: GET_MY,
    work: REQUEST_SILVERDAT_GET,
    post: {
      vin,
    },
    gate: REQUEST_SILVERDAT_GET,
    path: `/orb/silverdat/vin`,
    callback,
  };
}

export function addCarCollectDocument(vehicleId, docId, callback) {
  return {
    type: GET_MY,
    work: ADD_CAR_COLLECT_DOCUMENT,
    gate: `${ADD_CAR_COLLECT_DOCUMENT}_${vehicleId}_${docId}`,
    path: `/carcollect/add-document/${vehicleId}/${docId}`,
    put: {},
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function addCarCollectInvoice(vehicleId, invoiceId, callback) {
  return {
    type: GET_MY,
    work: ADD_CAR_COLLECT_INVOICE,
    gate: `${ADD_CAR_COLLECT_INVOICE}_${vehicleId}_${invoiceId}`,
    path: `/carcollect/add-invoice/${vehicleId}/${invoiceId}`,
    put: {},
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function carcollectAwards(carCollectVehicleId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_CAR_COLLECT,
    gate: REQUEST_CAR_COLLECT_AWARDS,
    path: `/carcollect/get-awards-number/${carCollectVehicleId}`,
    callback,
  };
}

export function carcollectCreate(vehicleId, callback, credentialId = null) {
  const putData = { vehicleId };
  if (credentialId) {
    putData.credentialId = credentialId;
  }
  
  return {
    type: GET_MY,
    work: REQUEST_CAR_COLLECT,
    gate: REQUEST_CAR_COLLECT_CREATE,
    put: putData,
    path: `/carcollect/create`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function getTradeInVehiclesList(options) {
  const work = options.isBulkAction ? `${REQUEST_VEHICLES + '_bulkAction'}` : REQUEST_VEHICLES;
  return {
    type: GET_MY,
    id: REQUEST_VEHICLES,
    work: work,
    gate: REQUEST_VEHICLES,
    path: `vehicles/tradeInList?companyId=${options.companyId}`,
  };
}

export function copyVehicleOptionsToTargetVehicle(vehicleId, copyFromVehicleId, callback) {
  return {
    type: GET_MY,
    work: COPY_VEHICLE_OPTIONS_TO_TARGET_VEHICLE,
    gate: COPY_VEHICLE_OPTIONS_TO_TARGET_VEHICLE,
    vehicleId,
    post: {},
    path: `vehicles/${vehicleId}/copy-options/${copyFromVehicleId}`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function copyVehicleGeneralPhothosToTargetVehicle(vehicleId, copyFromVehicleId, callback) {
  return {
    type: GET_MY,
    work: COPY_VEHICLE_GENERAL_PHOTOS_TO_TARGET_VEHICLE,
    gate: COPY_VEHICLE_GENERAL_PHOTOS_TO_TARGET_VEHICLE,
    vehicleId,
    post: {},
    path: `/vehicles/${vehicleId}/copy-general-photos/${copyFromVehicleId}`,
    putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function requestOrehVehicleExport(vehicleId, data, callback) {
  return {
    type: GET_MY,
    work: REQUEST_OREH_VEHICLE_EXPORT,
    gate: REQUEST_OREH_VEHICLE_EXPORT,
    patch: { ...data },
    path: `/orb/request-oreh-export/${vehicleId}`,
    putOnComplete: [fetchVehicle(vehicleId)],
    vehicleId,
    callback,
  };
}

export function fetchVehicleRecommendations(vehicleId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_RECOMMENDATIONS,
    vehicleId,
    work: [REQUEST_VEHICLE_RECOMMENDATIONS, `${REQUEST_VEHICLE_RECOMMENDATIONS}-${vehicleId}`],
    gate: REQUEST_VEHICLE_RECOMMENDATIONS + vehicleId,
    path: `vehicles/${vehicleId}/recommendations`,
    callback,
  };
}

export function switchVehicleRdwDates(vehicleId, callback) {
  return {
    type: GET_MY,
    work: SWITCH_VEHICLE_RDW_DATES,
    gate: SWITCH_VEHICLE_RDW_DATES,
    // vehicleId,
    post: {},
    path: `vehicles/${vehicleId}/switch-rdw-dates`,
    // putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

export function copyVehicle(vehicleId, dto, callback) {
  return {
    type: GET_MY,
    work: COPY_VEHICLE,
    gate: COPY_VEHICLE,
    post: dto,
    path: `vehicles/copy-vehicle/${vehicleId}`,
    // putOnComplete: [fetchVehicle(vehicleId)],
    callback,
  };
}

// Workflow management

export function getVehicleWorkflowTasks(vehicleId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_VEHICLE_WORKFLOW_TASKS,
    gate: REQUEST_VEHICLE_WORKFLOW_TASKS + vehicleId,
    path: `workflows-management/change-workflow-action-for-vehicle/${vehicleId}`,
    callback,
  };
}

export function assignWorkflowToVehicle(dto, callback) {
  return {
    type: GET_MY,
    work: ASSIGN_WORKFLOW_TO_VEHICLE,
    gate: ASSIGN_WORKFLOW_TO_VEHICLE,
    post: dto,
    path: `workflows-management/assign-workflow`,
    putOnComplete: [fetchVehicle(dto?.vehicleId), fetchVehicleTasks(dto?.vehicleId)],
  };
}
